import BaseController from "vamos/cockpit/base/controller/type/BaseController";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import { ExcelStartResponse, ExcelStatusResponse } from "vamos/cockpit/model/api/vamos.private.api.types";
import AppResponse from "vamos/cockpit/model/api/AppResponse";
import Dialog from "sap/m/Dialog";
import getText from "vamos/cockpit/base/handler/Text";
import FileService from "vamos/cockpit/base/services/file/FileService";
import JSONModel from "sap/ui/model/json/JSONModel";

export default class ExcelFileHandler {

    private controller: BaseController;

    private statusInterval: NodeJS.Timeout | string | number | undefined;

    private progressDialog: Dialog;

    private fileService: FileService;

    private currentExcelGuid: string;

    public constructor(controller: BaseController) {
        this.controller = controller;
        this.progressDialog = this.controller.getXmlFragment("vamos.cockpit.base.view.fragments.ProgressDialog") as Dialog;
        this.progressDialog.attachAfterClose(() =>{
            clearInterval(this.statusInterval);
        });
        this.fileService = new FileService(controller);
    }

    public async createExcelFile(p_PathParam: string, p_arPayLoad: object, p_sFileName: string) {
        const excelStartResponse: AppResponse<ExcelStartResponse> = await ApiService.getInstance().postRestJsonData(p_PathParam, p_arPayLoad);

        this.afterExcelFileCreated(excelStartResponse, p_sFileName);
    };

    private afterExcelFileCreated(oResponse: AppResponse<ExcelStartResponse>, p_sFileName : string) {
        this.currentExcelGuid = oResponse.data.guid;
        this.statusInterval = setInterval(() => {
            ApiService.getInstance().getRestJsonData(`/excel/status/${this.currentExcelGuid}`).then(async (response) => {
                await this.checkExcelStatus(response, p_sFileName);
            }, () => {
                clearInterval(this.statusInterval);
            });
        }, 1000);

        this.progressDialog.setTitle(getText("EXCEL_PROGRESS_TITLE"));
        this.progressDialog.open();
    }

    private async checkExcelStatus(response: ExcelStatusResponse, p_sFileName : string) {
        const oViewModel = this.controller.getModel("view") as JSONModel;
        const sStep = response.currentStep;
        if (sStep === "FINISH_GENERATION") {
            clearInterval(this.statusInterval);
            this.progressDialog.close();
            await this.fileService.downloadFile(`/excel/download/${this.currentExcelGuid}`, null,
                p_sFileName, "xlsx", true, "GET", () => {
                this.controller.getModel().refresh();
            });
            return;
        }
        const stepPercentage = response.currentStepCount / response.maxStepCount;
        const currentStepPercentage = (response.currentStepProgress / response.maxStepCount + stepPercentage) * 100;

        oViewModel.setProperty("/CurrentStep", getText("EXCEL_" + sStep));
        oViewModel.setProperty("/StepPercentage", currentStepPercentage);
        oViewModel.setProperty("/StepText", "");
    }
}
